<template>
  <div class="div" v-loading="loading">
    <div class="div-center">
      <el-tabs
        v-model="activeName"
        type="card"
        style="height: 100%"
        @tab-click="tabClick"
      >
        <el-tab-pane label="全周期成本分析" name="FullCycleCostEcharts">
          <div class="div-top">
            <span style="font-size: 14px">截止日期：</span>
            <el-date-picker
              v-model="searchData.YearMonth"
              :clearable="false"
              format="yyyyMM"
              value-format="yyyyMM"
              @change="getEchartsData"
              type="month"
              style="width: 300px; margin-left: 10px"
              placeholder="请选择月份"
            >
            </el-date-picker>
          </div>
          <div class="tab-chart">
            <el-card style="width: 49%; height: 98%" header="全周期成本分布">
              <div class="tab-chart-container"></div>
            </el-card>
            <el-card style="width: 49%; height: 98%" header="全周期成本占比">
              <div class="tab-chart-pie"></div>
            </el-card>
          </div>
        </el-tab-pane>
        <el-tab-pane label="全周期成本" name="FullCycleCost">
          <div class="div-top">
            <span style="font-size: 14px">截止日期：</span>
            <el-date-picker
              v-model="searchData.YearMonth"
              :clearable="false"
              format="yyyyMM"
              value-format="yyyyMM"
              @change="handleSearch"
              type="month"
              style="width: 300px; margin-left: 10px"
              placeholder="请选择月份"
            >
            </el-date-picker>
            <el-button
              type="primary"
              @click="handleSearch"
              style="margin-left: 10px"
              >查询</el-button
            >
            <el-button
              type="warning"
              @click="handleExport"
              style="margin-left: 10px"
              icon="el-icon-download"
              >导出数据</el-button
            >
          </div>
          <el-table
            :data="tableData"
            ref="table"
            style="width: 100%"
            height="calc(100% - 90px)"
          >
            <el-table-column
              label="设备分类"
              align="center"
              prop="DeviceTypeName"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="设备编号"
              align="center"
              prop="DeviceCode"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="设备名称"
              align="center"
              prop="device_name"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="安装位置"
              align="center"
              prop="Position"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="购置金额"
              align="right"
              prop="purchase_price"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.purchase_price, 2) }}
              </template>
            </el-table-column>
            <el-table-column label="能耗" align="center">
              <el-table-column
                label="电"
                align="right"
                prop="ElectricityAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.ElectricityAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="水"
                align="right"
                prop="WaterAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.WaterAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="气"
                align="right"
                prop="GasAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.GasAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="小计"
                align="right"
                prop="EnergyAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.EnergyAmount, 2) }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="机物料摊销"
              align="right"
              prop="AmortizationAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.AmortizationAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              label="外委维修"
              align="right"
              prop="OutsourcingAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.OutsourcingAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              label="成本总计"
              align="right"
              prop="TotalAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.TotalAmount, 2) }}
              </template>
            </el-table-column>
          </el-table>
          <div
            style="
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: right;
            "
          >
            <el-pagination
              style="margin-top: 10px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.PageIndex"
              :page-sizes="pagination.PageSizes"
              :page-size="pagination.PageRows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
import * as echarts from 'echarts'
export default {
  data() {
    return {
      tools,
      moment,
      searchData: {
        YearMonth: '',
      },
      rDate: [],
      tableData: [],
      totalData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
      activeName: 'FullCycleCostEcharts',
      searchYear: '',
      chartData: [],
      chartColors: [
        '#5470C6',
        '#91CC75',
        '#EE6666',
        '#FAC858',
        '#73C0DE',
        '#3BA272',
        '#FC8452',
        '#9A60B4',
        '#EA7CCC',
        '#FF9F7F',
        '#B6A2DE',
        '#2EC7C9',
        '#B7A2DE',
        '#FFB980',
        '#5AB1EF',
      ],
    }
  },
  props: {},
  components: {},
  methods: {
    tabClick(tab) {
      this.activeName = tab.name
      this.chartData = []
      if (this.activeName === 'FullCycleCostEcharts') {
        this.getEchartsData()
      } else {
        this.getDataList()
      }
    },
    handleExport() {
      if (this.searchData.YearMonth) {
        tools.download(
          this.$rootUrl +
            `/Base_DeviceTreeManage/DeviceItem/DeviceItemCostExportToExcel?DeviceType=${
              this.devTreeSearch.DeviceType || ''
            }&BuildingId=${
              this.devTreeSearch.BuildingId || ''
            }&InstallationArea=${
              this.devTreeSearch.InstallationArea || ''
            }&YearMonth=${this.searchData.YearMonth || ''}`,
          '全周期成本',
          '.xlsx',
          'get'
        )
      } else {
        return this.$notify.warning('请选择年月后导出')
      }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    fun(val) {
      return '折旧总金额：' + (Number(val) === 0 ? 0 : Number(val).toFixed(2))
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/DeviceItem/GetDeviceItemCostList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'Id',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'YearMonth',
              Keyword: this.searchData.YearMonth || '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      if (this.searchData.YearMonth) {
        this.pagination.PageIndex = 1
        this.getDataList()
      } else {
        return this.$notify.warning('请选择年月后查询')
      }
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    getEchartsData() {
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/DeviceItem/GetDeviceItemCostListAnalysis',
          {
            Search: [
              {
                Condition: 'DeviceType',
                Keyword: this.devTreeSearch.DeviceType || '',
              },
              {
                Condition: 'BuildingId',
                Keyword: this.devTreeSearch.BuildingId || '',
              },
              {
                Condition: 'InstallationArea',
                Keyword: this.devTreeSearch.InstallationArea || '',
              },
              {
                Condition: 'YearMonth',
                Keyword: this.searchData.YearMonth,
              },
            ],
          }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.chartData = (res.Data || []).map((item) => ({
              ...item,
              value: item.value !== undefined ? item.value : item.vlaue,
            }))
            this.renderPieChart()
            this.renderEcharts()
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    renderPieChart() {
      const dom = document.querySelector('.tab-chart-pie')
      if (!dom) return
      if (dom.__echarts__) dom.__echarts__.dispose()
      const myChart = echarts.init(dom)
      const option = {
        color: this.chartColors,
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `${params.name}<br/>${this.$tools.momenyFormat(
              params.value,
              2
            )} (${params.percent}%)`
          },
        },
        legend: {},
        series: [
          {
            name: '全周期成本',
            type: 'pie',
            radius: '60%',
            center: ['50%', '55%'],
            data: this.chartData.map((i) => ({ name: i.name, value: i.value })),
            label: {
              formatter: (params) =>
                `${params.name}: ${this.$tools.momenyFormat(
                  params.value,
                  2
                )} (${params.percent}%)`,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
      myChart.setOption(option)
    },
    renderEcharts() {
      const dom = document.querySelector('.tab-chart-container')
      if (!dom) return
      if (dom.__echarts__) dom.__echarts__.dispose()
      const myChart = echarts.init(dom)
      const option = {
        tooltip: {
          formatter: (params) => {
            return `${
              params.seriesName
            }<br/><span style="width:10px;height:10px;display:inline-block;background-color:${
              params.color
            };border-radius:50%;margin-right:5px"></span>${
              params.name
            }<span style="font-weight:bold;margin-left:10px">${this.$tools.momenyFormat(
              params.value,
              2
            )}</span>`
          },
        },
        grid: { left: 60, top: 60, right: 40, bottom: 40 },
        xAxis: {
          type: 'category',
          data: this.chartData.map((i) => i.name),
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: '全周期成本',
            type: 'bar',
            data: this.chartData.map((i) => i.value),
            label: {
              show: true,
              formatter: (params) => this.$tools.momenyFormat(params.value, 2),
            },
            itemStyle: {
              color: function (params) {
                const colors = [
                  '#5470C6',
                  '#91CC75',
                  '#EE6666',
                  '#FAC858',
                  '#73C0DE',
                  '#3BA272',
                  '#FC8452',
                  '#9A60B4',
                  '#EA7CCC',
                  '#FF9F7F',
                  '#B6A2DE',
                  '#2EC7C9',
                  '#B7A2DE',
                  '#FFB980',
                  '#5AB1EF',
                ]
                return colors[params.dataIndex % colors.length]
              },
            },
          },
        ],
      }
      myChart.setOption(option)
    },
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      if (this.activeName === 'FullCycleCostEcharts') {
        this.getEchartsData()
      } else {
        this.handleSearch()
      }
    },
  },
  mounted() {
    this.activeName = 'FullCycleCostEcharts'
    this.searchData.YearMonth = moment().format('YYYYMM')
    this.getEchartsData()
  },
  created() {},
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  line-height: 30px;
  margin-bottom: 10px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  height: calc(100%);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
.tab-chart {
  width: 100%;
  height: calc(100% - 30px);
  display: flex;
  justify-content: space-between;
}
::v-deep .el-card__body {
  width: 100%;
  height: calc(100% - 58px);
}
::v-deep .el-card__header {
  font-weight: bold;
}
.tab-chart-pie {
  width: 100%;
  height: 100%;
}
.tab-chart-container {
  width: 100%;
  height: 100%;
}
::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
</style>
